import { applyMiddleware, createStore, compose, Store, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import config from '../config';
import rootReducer from './reducer';
import { ApplicationState } from './types';
import { autoRehydrate } from 'redux-phoenix';
import { configureStore } from '@reduxjs/toolkit';
import { cartSlice } from './slices/CartSlice';
import InternationalisationReducer from './reducers/InternationalisationReducers';
import RecruitmentsReducer from './reducers/recruitments';
import StoreArticleReducer from './reducers/storeArticles';
import { selectedProductSlice } from './slices/SelectedProductSlice';

const loggerMiddleware = createLogger();

const middlewares = [];

// @ts-ignore
middlewares.push(thunkMiddleware);
if (config.env === 'DEV') {
  // @ts-ignore
  middlewares.push(loggerMiddleware);
}

const middlewareEnhancer = composeWithDevTools(
  applyMiddleware(...middlewares),
  autoRehydrate
);

const enhancers = [middlewareEnhancer];
const composedEnhancers = compose(...enhancers);

// const store: Store<ApplicationState> = createStore(
//   rootReducer,
//   //@ts-ignore
//   composedEnhancers
// );

export const store: Store<ApplicationState> = configureStore({
  reducer: {
    i18n: InternationalisationReducer,
    recruitments: RecruitmentsReducer,
    shop: StoreArticleReducer,
    cart: cartSlice.reducer,
    selectedProduct: selectedProductSlice.reducer,
  },
  devTools: true,
});

export default store;
